import * as Axios from 'axios';
import { getAuthHeaders } from './request';

const userPreferencesRequest = async (method, path, params = {}, authHeaders = false, data = {}, withCredentials = true) => {
  let request = null
  let headers = {};
  if (authHeaders) {
    headers = getAuthHeaders();
  }
  if (params.headers != null) {
    headers = {
      ...headers,
      ...params.headers,
    };
  }

  try {
    request = await Axios({
      baseURL: window.__env.REACT_APP_USER_API_URL,
      data,
      headers,
      method,
      params: params.queryParams,
      url: `user/preferences/${path}`,
      withCredentials
    })
  } catch (error) {
    return { success: false, data: error };
  }

  return { success: true, data: request.data.result };
};

export default userPreferencesRequest
